module.exports = __webpack_public_path__ + "static/media/fly0204.66ac66fd.webp";